var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24893 4.26343C1.45382 4.26343 1.61992 4.09733 1.61992 3.89243V2.40844C1.61992 2.31005 1.65901 2.21568 1.72859 2.1461C1.79816 2.07653 1.89253 2.03744 1.99092 2.03744H7.18489C7.28328 2.03744 7.37765 2.07653 7.44722 2.1461C7.5168 2.21568 7.55589 2.31005 7.55589 2.40844V3.89243C7.55589 4.09733 7.72199 4.26343 7.92688 4.26343C8.13178 4.26343 8.29788 4.09733 8.29788 3.89243V2.40844C8.29788 2.11326 8.18062 1.83016 7.97189 1.62144C7.76317 1.41271 7.48007 1.29545 7.18489 1.29545H1.99092C1.69574 1.29545 1.41264 1.41271 1.20392 1.62144C0.995191 1.83016 0.87793 2.11326 0.87793 2.40844V3.89243C0.87793 4.09733 1.04403 4.26343 1.24893 4.26343Z",
    fill: "#0D99FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32547 8.60667C4.47035 8.75155 4.70525 8.75155 4.85014 8.60667L6.70512 6.75168C6.85001 6.6068 6.85001 6.3719 6.70512 6.22701C6.56024 6.08213 6.32534 6.08213 6.18045 6.22701L4.5878 7.81966L2.99515 6.22701C2.85027 6.08213 2.61536 6.08213 2.47048 6.22701C2.3256 6.3719 2.3256 6.6068 2.47048 6.75168L4.32547 8.60667Z",
    fill: "#0D99FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58779 8.71533C4.79269 8.71533 4.95879 8.54923 4.95879 8.34433V3.89236C4.95879 3.68747 4.79269 3.52137 4.58779 3.52137C4.3829 3.52137 4.2168 3.68747 4.2168 3.89236V8.34433C4.2168 8.54923 4.3829 8.71533 4.58779 8.71533Z",
    fill: "#0D99FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.15b75a2d93fbd9d299b0bf77ce07ed7a.svg";
export { ForwardRef as ReactComponent };